import { TFormInstance } from 'components/Base/Form/Form.types';

export enum ELoginText {
  TITLE = 'Welcome back!',
  EMAIL_DESCRIPTION = 'Enter your credentials to login',
  PHONE_DESCRIPTION = 'Enter your credentials to login',
}

export enum EVerificationText {
  TITLE = 'Verification code',
  EMAIL_DESCRIPTION = "We've sent a login code to your email address, please check and enter it below to login.",
  PHONE_DESCRIPTION = "We've sent a login code to your phone number, please check and enter it below to login.",
}

export enum EFormIds {
  EMAIL_LOGIN = 'email-login-form',
  PHONE_LOGIN = 'phone-login-form',
  VERIFICATION = 'verification-form',
}

export enum ELoginErrors {
  UserNotFoundException = 'Incorrect username or password.',
}

export type TLoginPhoneNumberData = { phoneNumber: string; password: string };

export type TLogInPhoneNumberProps = {
  onViaChanged: () => void;
  onSubmit: (values: TLoginPhoneNumberData) => void;
  userCredential: {
    phoneNumber?: string | null;
    password?: string | null;
  };
  isLoading?: boolean;
};

export type TLoginPhoneNumberFormProps = {
  form: TFormInstance<TLoginPhoneNumberData>;
  viaEmail?: boolean;
  error?: string;
  userCredential: {
    phoneNumber?: string | null;
    password?: string | null;
  };
  isLoading?: boolean;
};

export type TLoginEmailData = { email: string; password: string };

export type TLogInEmailProps = {
  onViaChanged: () => void;
  onSubmit: (values: TLoginEmailData) => void;
  userCredential: {
    email?: string | null;
    password?: string | null;
  };
  isLoading?: boolean;
};

export type TLoginEmailFormProps = {
  form: TFormInstance<TLoginEmailData>;
  viaEmail?: boolean;
  error?: string;
  userCredential?: {
    email?: string | null;
    password?: string | null;
  };
  isLoading?: boolean;
};

export type TVerificationData = { verificationCode: string };

export type TVerificationFormProps = {
  form: TFormInstance<TVerificationData>;
  verificationCodeLength?: number;
  error?: string;
  isLoading?: boolean;
};

export type TCredentials = {
  username: string;
  password: string;
};
